import { useCallback } from 'react';
import styled from 'styled-components';
import ResultImageGrid from 'root/components/ResultImageGrid';
import { useAssets, useUI } from '../../selectors';
import { THUMBNAIL_WIDTH_WHEN_PANEL_OPENED } from '../../../../common/consts';
import FiltersSummary from './FiltersSummary';

const GridBox = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 51px);
`;

export default ({ handleSearch, onSelect }) => {
  const { items, assetsInProgress, page, hasMoreAssets, selected } = useAssets();
  const { isFiltersPanelOpen } = useUI();

  const onLoadMore = useCallback(() => {
    if (hasMoreAssets) {
      handleSearch({ page: page + 1 });
    }
  }, [hasMoreAssets, handleSearch, page]);

  return (
    <GridBox data-test="search-page-results-container">
      <FiltersSummary />
      <ResultImageGrid
        images={items}
        selected={selected}
        selectionAction={onSelect}
        showProgressIndicator={assetsInProgress}
        isMultiple={false}
        onLoadMore={onLoadMore}
        itemWidth={isFiltersPanelOpen ? THUMBNAIL_WIDTH_WHEN_PANEL_OPENED : null}
        topBarRenderer={null}
        hasMore={hasMoreAssets}
      />
    </GridBox>
  );
};
